/**
 * Tailwind className strings for table layout.
 */

/** Standard table wrapper — rounded border, horizontal scroll on narrow viewports. */
export const tableWrapperClassName =
  "overflow-x-auto rounded-lg border flex flex-col flex-1 min-h-0 shadow-xs";

/** Filter/search bar above a table. Children are expected to be `filterSearchClassName` or `filterComboboxClassName` wrappers. */
export const fileFiltersBoxClassName =
  "mb-1 hidden sm:flex flex-wrap items-end gap-x-3 gap-y-1 py-1.5";

/** Wrapper for the search input in a filter bar — flex-grows, minimum readable width. */
export const filterSearchClassName =
  "flex-1 min-w-[240px] space-y-0.5";

/** Wrapper for a single filter combobox in a filter bar — grows to share
 *  row space with sibling filters/search, with a 160px floor so narrow
 *  filters don't collapse below readable placeholder width. Selected values
 *  that still overflow are disclosed via a tooltip in `FilterCombobox`.
 *  Uses label-targeted margin instead of space-y to avoid adding margin to
 *  the hidden input rendered by base-ui Combobox. */
export const filterComboboxClassName =
  "flex-1 min-w-[160px] [&>label]:mb-0.5";

/* ── Drawer-specific variants ──────────────────────────────────────────
 * Drawer-internal tables render inside a 384px panel. The page-level
 * styles above use viewport media queries (`hidden sm:flex`) and fixed
 * widths that don't fit, so drawer tables use these instead.
 */

/** Filter bar for drawer-internal tables — always visible, vertical stack. */
export const drawerFiltersBoxClassName =
  "mb-2 flex flex-col gap-3";

/** Search input wrapper inside a drawer filter bar — full width, no min-w. */
export const drawerSearchClassName =
  "space-y-1.5";

/** Filter combobox wrapper inside a drawer filter bar — full width. */
export const drawerFilterItemClassName =
  "[&>label]:mb-1.5";

/** Table wrapper for drawer-internal tables. Currently identical to
 *  `tableWrapperClassName`; kept as a separate export so drawer call-sites
 *  stay grouped with the other drawer-specific style exports. */
export const drawerTableWrapperClassName =
  "overflow-x-auto rounded-md border flex flex-col flex-1 min-h-0";
